import { render, staticRenderFns } from "./ScoreDetailComplianceSummary.vue?vue&type=template&id=12647f1a&"
import script from "./ScoreDetailComplianceSummary.vue?vue&type=script&lang=js&"
export * from "./ScoreDetailComplianceSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports